import { ContactRequestDto, Pagination, PaginationQuery } from '@libs/dto';
import { ContactRequest } from '@libs/models';
import { PostRequestStatus } from '@libs/types';

import { api } from '../common.api';

export const contactRequestApi = api.injectEndpoints({
  endpoints: (build) => ({
    contactRequestCreate: build.mutation<ContactRequest, ContactRequestDto>({
      query: (body) => ({
        url: '/post/contact-request',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ContactRequest'],
    }),
    contactRequestAdminSearch: build.query<Pagination<ContactRequest>, PaginationQuery>({
      query: ({ q = '', page = 1, limit = 10 } = {}) => ({
        url: '/post/contact-request/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['ContactRequest'],
    }),
    contactRequestUpdateStatus: build.mutation<ContactRequest, { id: number; status: PostRequestStatus }>({
      query: ({ id, status }) => ({
        url: `/post/contact-request/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: ['ContactRequest'],
    }),
  }),
});

export const {
  useContactRequestCreateMutation,
  useContactRequestAdminSearchQuery,
  useContactRequestUpdateStatusMutation,
} = contactRequestApi;
